import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

const Hero = () => {
  const { toast } = useToast();

  const showNotImplementedToast = () => {
    toast({
      title: "🚧 !",
      description: "! 🚀",
      duration: 3000,
    });
  };

  const scrollToRaces = () => {
    const raceSection = document.getElementById("race-info");
    if (raceSection) raceSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* HERO IMAGE (ganti src ini) */}
      <img
        src="/images/hero.jpeg"
        alt="Banyumas Ultra"
        className="absolute inset-0 z-0 w-full h-full object-cover"
      />

      {/* overlay gelap */}
      <div className="absolute inset-0 bg-black/60 z-10" />

      {/* konten */}
      <div className="relative z-20 flex flex-col items-center justify-center h-full text-center text-white px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex flex-col items-center"
        >
          <p className="mb-4 text-lg font-semibold tracking-widest uppercase text-orange-400"
          style={{ textShadow: "0 0 8px rgba(255,165,0,0.8)" }}>
            BANYUMAS ULTRA SERIES EVENT
          </p>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter leading-tight">
            Banyumas<br />Ultra
          </h1>

          <p className="mt-6 max-w-2xl text-lg md:text-xl text-orange-400 font-semibold"
          style={{ textShadow: "0 0 10px rgba(255,165,0,0.8)" }}>
            18 - 19 APRIL 2026 • Taklukkan jalur menantang di kaki Gunung Slamet dalam
            petualangan lari yang tak terlupakan.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href="https://sobat.id/events/b-ultra"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                size="lg"
                className="bg-orange-500 hover:bg-orange-400 text-white font-bold shadow-[0_0_20px_rgba(255,140,0,0.7)]"
              >
                Daftar Sekarang
              </Button>
            </a>

            <Button
              onClick={scrollToRaces}
              size="lg"
              variant="outline"
              className="border-primary text-primary hover:bg-primary/10 font-bold"
            >
              Lihat Lomba
            </Button>
          </div>
        </motion.div>

        <motion.button
          onClick={scrollToRaces}
          className="absolute bottom-10"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        >
          <ArrowDown className="h-8 w-8 text-white/70" />
        </motion.button>
      </div>
    </div>
  );
};

export default Hero;